import React from 'react';
import { MailIcon, PhoneIcon, BriefcaseIcon, CpuIcon, LinkedinIcon, DollarSignIcon, UsersIcon, TagsIcon, ClockIcon } from 'lucide-react';
export function EnrichmentFields() {
  return <section className="py-24 bg-slate-50" data-id="element-4312">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4313">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-4314">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-4315">
            What our local business contact{' '}
            <span className="text-blue-600" data-id="element-4316">enrichment</span> adds to every
            record
          </h2>
          <p className="text-xl text-slate-600" data-id="element-4317">
            Turn basic local business names into complete, actionable profiles
            with 50+ enriched data fields.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4318">
          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4319">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4320">
              <MailIcon className="w-6 h-6" data-id="element-4321" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4322">
              Owner emails
            </h3>
            <p className="text-slate-600" data-id="element-4323">
              Verified email addresses for local business owners and
              decision-makers.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4324">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4325">
              <PhoneIcon className="w-6 h-6" data-id="element-4326" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4327">
              Direct phones
            </h3>
            <p className="text-slate-600" data-id="element-4328">
              Direct dial and mobile numbers for key local business contacts.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4329">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4330">
              <BriefcaseIcon className="w-6 h-6" data-id="element-4331" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4332">
              Job titles
            </h3>
            <p className="text-slate-600" data-id="element-4333">
              Accurate roles like Founder, GM, or Marketing Director.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4334">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4335">
              <CpuIcon className="w-6 h-6" data-id="element-4336" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4337">
              Tech stack
            </h3>
            <p className="text-slate-600" data-id="element-4338">
              Technologies used by the local business (Shopify, Toast,
              Mindbody).
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4339">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4340">
              <LinkedinIcon className="w-6 h-6" data-id="element-4341" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4342">
              Social profiles
            </h3>
            <p className="text-slate-600" data-id="element-4343">
              LinkedIn, Instagram, and Facebook profiles for the business and
              owners.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4344">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4345">
              <DollarSignIcon className="w-6 h-6" data-id="element-4346" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4347">
              Revenue estimates
            </h3>
            <p className="text-slate-600" data-id="element-4348">
              Estimated annual revenue to help qualify your local business
              leads.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4349">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4350">
              <UsersIcon className="w-6 h-6" data-id="element-4351" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4352">
              Employee count
            </h3>
            <p className="text-slate-600" data-id="element-4353">
              Accurate company size metrics for better segmentation.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4354">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4355">
              <TagsIcon className="w-6 h-6" data-id="element-4356" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4357">
              Business categories
            </h3>
            <p className="text-slate-600" data-id="element-4358">
              Primary and secondary industry classifications.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-4359">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-4360">
              <ClockIcon className="w-6 h-6" data-id="element-4361" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-4362">
              Operating hours
            </h3>
            <p className="text-slate-600" data-id="element-4363">
              Daily open and close times from their local business profile.
            </p>
          </div>
        </div>
      </div>
    </section>;
}